import type { ContentTab } from "@/v2/framework/dialog/types";
import type { FeedConfigDialogApi } from "../types";

export function buildFeedConfigTab(
  api: FeedConfigDialogApi,
  options?: { id?: string; label?: string },
): ContentTab {
  return {
    id: options?.id ?? "feed-config",
    label: options?.label ?? "Feed config",
    children: [
      {
        type: "component",
        component: () => import("../components/FeedConfigDialogTab.vue"),
        props: { feedConfigApi: api },
      },
    ],
  };
}
